import dayjs from "dayjs"

// $cache startDate/endDate 默认值
let startDate = dayjs().subtract(7, 'day').format('YYYY-MM-DD'),
    endDate = dayjs().format('YYYY-MM-DD'),
    expire = dayjs(dayjs().add(1, 'day').format("YYYY-MM-DD")).diff(dayjs(), 's')
export default {
    // base
    "home": {
        meta: {
            title: "首页"
        },
        name: 'home',
        component: () =>
            import('_v/home/index')
    },
    "api/admin/sys/org/index": {
        meta: {
            title: '组织机构管理'
        },
        name: "org",
        component: () =>
            import('_v/admin/sys/org/index')
    },
    "api/admin/sys/auth/index": {
        meta: {
            title: '功能授权',
        },
        path: 'authResources',
        name: 'authResources',
        component: () =>
            import('_v/admin/sys/org/auth')
    },
    "api/admin/sys/dict/index": {
        meta: {
            title: '词典管理'
        },
        name: "dict",
        component: () =>
            import('_v/admin/sys/dict/index')
    },
    "api/admin/sys/resource/index": {
        meta: {
            title: '资源管理'
        },
        component: () =>
            import('_v/admin/sys/resource/index')
    },
    "api/admin/sys/data/auth/index": {
        meta: {
            title: "数据授权"
        },
        name: "dataAuth",
        component: () => import("_v/admin/data-auth/index")
    },
    "api/lltt/brand/manage/index": {
        path: 'brand-manage',
        name: 'brand-manage',
        meta: {
            title: '品牌管理',
        },
        component: () =>
            import('_v/brand-manage/list-brand')
    },
    "api/lltt/order/manage/index": {
        path: 'order-manage',
        name: 'order-manage',
        meta: {
            title: '工单管理',
            cache: {
                customerId: {
                    defaultVal: '', // 默认值
                    expire, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                startDate: {
                    defaultVal: startDate, // 默认值
                    expire, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                endDate: {
                    defaultVal: endDate, // 默认值
                    expire, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                orderStatusWait: {
                    defaultVal: "", // 默认值
                    expire: 0, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                orderStatusAlready: {
                    defaultVal: "", // 默认值
                    expire: 0, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                orderNo: {
                    defaultVal: "", // 默认值
                    expire: 0, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                serviceType: {
                    defaultVal: "", // 默认值
                    expire: 0, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                orderDataSource: {
                    defaultVal: "G", // 默认值
                    expire: 0, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
            },
        },
        component: () =>
            import('_v/order-manage/order-index'),
        children: {
            "api/lltt/order/wait/index": {
                meta: {
                    title: "待派工单",
                },
                name: "orderWait",
                component: () => import("_v/order-manage/order-wait/list-order")
            },
            "api/lltt/order/already/index": {
                meta: {
                    title: "已派工单",
                },
                name: "orderAlready",
                component: () => import("_v/order-manage/order-already/list-order")
            },
            "api/lltt/order/analysis/index": {
                meta: {
                    title: "待派工单"
                },
                name: "orderAnalysis",
                component: () => import("_v/order-manage/order-analysis/list-order")
            },
            "api/lltt/order/monitor/index": {
                meta: {
                    title: "工单监控"
                },
                name: "orderMonitor",
                component: () => import("_v/order-manage/order-monitor/list-order")
            },
            "api/lltt/order/consult/index": {
                meta: {
                    title: "工单咨询"
                },
                name: "orderConsult",
                component: () => import("_v/order-manage/order-consult/list-order-consult")
            },
        }
    },
    "api/lltt/task/manage/index": {
        path: 'task-manage',
        name: 'task-manage',
        meta: {
            title: '任务管理',
            cache: {
                startDate: {
                    defaultVal: startDate, // 默认值
                    expire, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                endDate: {
                    defaultVal: endDate, // 默认值
                    expire, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                orderStatus: {
                    defaultVal: "", // 默认值
                    expire: 0, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                orderNo: {
                    defaultVal: "", // 默认值
                    expire: 0, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                serviceType: {
                    defaultVal: "", // 默认值
                    expire: 0, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                orderDataSource: {
                    defaultVal: "R", // 默认值
                    expire: 0, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
            },
        },
        component: () =>
            import('_v/task-manage/task-index'),
        children: {
            "api/lltt/task/list/index": {
                meta: {
                    title: "任务列表",
                },
                name: "taskList",
                component: () => import("_v/task-manage/task-list/list-task")
            },
            "api/lltt/task/analysis/index": {
                meta: {
                    title: "任务分析"
                },
                name: "taskAnalysis",
                component: () => import("_v/task-manage/task-analysis/list-task")
            },
            "api/lltt/task/monitor/index": {
                meta: {
                    title: "任务监控"
                },
                name: "taskMonitor",
                component: () => import("_v/order-manage/order-monitor/list-order")
            },
            "api/lltt/task/consult/index": {
                meta: {
                    title: "任务咨询"
                },
                name: "taskConsult",
                component: () => import("_v/order-manage/order-consult/list-order-consult")
            },
        }
    },
    "api/lltt/recycle/manage/index": {
        path: 'recycle-manage',
        name: 'recycle-manage',
        meta: {
            title: '回收管理',
            cache: {
                startDate: {
                    defaultVal: startDate, // 默认值
                    expire, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                endDate: {
                    defaultVal: endDate, // 默认值
                    expire, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                orderStatus: {
                    defaultVal: "", // 默认值
                    expire: 0, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                taskStatus: {
                    defaultVal: "", // 默认值
                    expire: 0, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                orderNo: {
                    defaultVal: "", // 默认值
                    expire: 0, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                serviceType: {
                    defaultVal: "", // 默认值
                    expire: 0, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
            },
        },
        component: () =>
            import('_v/recycle-manage/recycle-index'),
        children: {
            "api/lltt/order/recycle/index": {
                meta: {
                    title: "工单回收",
                },
                name: "recycleOrder",
                component: () => import("_v/recycle-manage/order-list")
            },
            "api/lltt/task/recycle/index": {
                meta: {
                    title: "任务回收"
                },
                name: "recycleTask",
                component: () => import("_v/recycle-manage/order-list")
            },
        }
    },
    "api/lltt/notify/manage/index": {
        path: 'information-manage',
        name: 'information-manage',
        meta: {
            title: '资讯管理',
        },
        component: () =>
            import('_v/information-manage/information-index'),
        children: {
            "api/lltt/notify/list/index": {
                meta: {
                    title: "公司资讯"
                },
                name: "notifyList",
                component: () => import("_v/information-manage/information-list/list-information")
            },
            "api/lltt/notify/advertising/index": {
                meta: {
                    title: "广告设置"
                },
                name: "notifyAdvertising",
                component: () => import("_v/information-manage/advertising")
            },
            "api/lltt/notify/set/index": {
                meta: {
                    title: "公司设置"
                },
                name: "notifySet",
                component: () => import("_v/information-manage/company-set")
            },
        }
    },
    "api/lltt/feedback/index": {
        path: 'feedback',
        name: 'feedback',
        meta: {
            title: '在线反馈',
            cache: {
                startDate: {
                    defaultVal: startDate, // 默认值
                    expire, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                endDate: {
                    defaultVal: endDate, // 默认值
                    expire, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
            },
        },
        component: () =>
            import('_v/feedback/list-feedback')
    },
    "api/lltt/customer/manage/index": {
        path: 'customer-manage',
        name: 'customer-manage',
        meta: {
            title: '客户管理',
            cache: {
                startDate: {
                    defaultVal: startDate, // 默认值
                    expire, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
                endDate: {
                    defaultVal: endDate, // 默认值
                    expire, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
            },
        },
        component: () =>
            import('_v/customer-manage/customer-index'),
        children: {
            "api/lltt/customer/list/index": {
                meta: {
                    title: "客户列表"
                },
                name: "customerList",
                component: () => import("_v/customer-manage/customer-list/list-customer")
            },
            "api/lltt/customer/evaluate/index": {
                meta: {
                    title: "客户评价"
                },
                name: "customerEvaluate",
                component: () => import("_v/customer-manage/customer-evaluate/list-evaluate")
            },
        }
    },
    "api/lltt/customer/outside/index": {
        path: 'customer-outside',
        name: 'customer-outside',
        meta: {
            title: '外部用户',
            cache: {
                customerId: {
                    defaultVal: "", // 默认值
                    expire: 0, // 到期时间/s，0=永久
                    query: false, // 是否区分查询字符串
                    user: false, // 是否区分用户
                },
            },
        },
        component: () =>
            import('_v/customer-outside/list-customer')
    },
    "api/lltt/customer/inside/index": {
        path: 'customer-inside',
        name: 'customer-inside',
        meta: {
            title: '内部用户',
        },
        component: () =>
            import('_v/customer-inside/list-customer')
    }
}